<div id="paymentRequest" [style.display]="ready && !success ? null : 'none'">
  <div id="payment-request-button"></div>

  <form [formGroup]="paymentForm" (ngSubmit)="onSubmit()" class="checkout">
    <p class="explainerText ion-text-center ion-text-wrap">
      <span>{{ legend }}</span
        >/<span id="generate">generate</span> your payment details below
      </p>
      <ion-item>
        <label for="card-info">Card Info</label>
        <div id="card-info" #cardInfo></div>

        @if (error) {
          <div id="card-errors" role="alert">{{ error }}</div>
        }
      </ion-item>
      @if (errorMessage) {
        <ion-item>
          {{ errorMessage }}
        </ion-item>
      }
      <ion-button type="submit" [disabled]="inProgress">Pay £{{ payment.amount / 100 }}</ion-button>
    </form>
  </div>
  @if (success) {
    <div>
      <ion-item> Your payment suceeded </ion-item>
    </div>
  }
